import { render, staticRenderFns } from "./ListBatch.vue?vue&type=template&id=7522d08d&"
import script from "./ListBatch.vue?vue&type=script&lang=js&"
export * from "./ListBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports